



























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import AddressForm from "@/components/AddressForm.vue";
import CompanyDetailsHelpers from "@/models/companyDetails";
import OrderHelpers, { Order } from "../../models/order";
import { Address } from "../../models/address";

@Component({
  components: {
    loader,
    AddressForm
  }
})
export default class BillingAddress extends Vue {
  @Mutation("setLastErr") public setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order?: Order;
  private loading = true;

  private valid = false;
  private setBillingAddress(add: Address) {
    this.$emit("update", { billing_address: add });
  }

  private next() {
    this.$emit("update", false, true, "confirm");
  }

  private back() {
    if (OrderHelpers.NeedShippingAddress(this.order)) {
      this.$router.push("shipping_address");
    } else {
      this.$router.push("packages");
    }
  }

  private randName() {
    let result = "";
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charsLen = chars.length;
    for (let i = 0; i < 20; i++) {
      result += chars.charAt(Math.floor(Math.random() * charsLen));
    }
    return result;
  }
}
